import React from 'react';

const AdminDashboard = React.lazy(() => import('./views/AdminServices/AdminDashboard/AdminDashboard'));
const BaseDashboard = React.lazy(() => import('./views/BaseServices/BaseDashboard/BaseDashboard'));
const ClientList = React.lazy(() => import('./views/AdminServices/ClientList/ClientList'));

const GCList = React.lazy(() => import('./views/AdminServices/GCList/GCList'));
const GCView = React.lazy(() => import('./views/AdminServices/ViewGC/ViewGC'));
const EditClient = React.lazy(() => import('./views/AdminServices/EditClient/EditClient'));
const ViewClient = React.lazy(() => import('./views/AdminServices/ViewClient/ViewClient'));
const BaseUsers = React.lazy(() => import('./views/AdminServices/BaseUsers/BaseUsers'));
const BaseList = React.lazy(() => import('./views/AdminServices/BaseList/BaseList'));
const MmscmUploadView = React.lazy(() => import('./views/AdminServices/MmscmUpload/MmscmUpload'));

const BaseClientList = React.lazy(() => import('./views/BaseServices/BaseClientList/BaseClientList'));
const BaseViewClient = React.lazy(() => import('./views/BaseServices/BaseViewClient/BaseViewClient'));

const ClientViewClient = React.lazy(() => import('./views/ClientServices/ViewClient/ViewClient'));
const ContactDetails = React.lazy(() => import('./views/ClientServices/ContactDetails/ContactDetails'));
const TermsAndConditions = React.lazy(() => import('./views/Pages/TermAndConditions/TermAndConditions'));
const PrivacyPolicy = React.lazy(() => import('./views/Pages/PrivacyPolicy/PrivacyPolicy'));
const ClientChangePassword = React.lazy(() => import('./views/ClientServices/ChangePassword/ChangePassword'));
const BaseChangePassword = React.lazy(() => import('./views/BaseServices/ChangePassword/ChangePassword'));

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/dashboard', name: 'Dashboard', component: AdminDashboard },
  { path: '/hub', name: 'Dashboard', component: BaseDashboard },
  { path: '/home', name: 'Dashboard', component: ClientViewClient },
  { path: '/customers/edit-:id', name: 'Edit Customer', component: EditClient },
  { path: '/customers/view-:id', name: 'View Customer', component: ViewClient },
  { path: '/customers', name: 'Customers', component: ClientList },
  { path: '/gc/view-:id', name: 'Gas Chromatograph', component: GCView},
  { path: '/gc', name: 'GC Meter', component: GCList },
  { path: '/base-users', name: 'Base Users', component: BaseUsers },
  { path: '/base-list', name: 'Base List', component: BaseList },
  { path: '/settings', name: 'Settings', component: MmscmUploadView },

  { path: '/base-customers/view-:id', name: 'View Customer', component: BaseViewClient },
  { path: '/base-customers', name: 'Base Users', component: BaseClientList },
  { path: '/contact-details', name: 'Contact Details', component: ContactDetails },
  { path: '/terms-and-conditions', name: 'Terms And Conditions', component: TermsAndConditions },
  { path: '/privacy-policy', name: 'Privacy Policy', component: PrivacyPolicy },
  { path: '/change-password', name: 'Change Password', component: ClientChangePassword },
  { path: '/password-change', name: 'Change Password', component: BaseChangePassword },

];

export default routes;
